import { IItemProperty, IItemManufacturer, ItemAttribute, IInformation, IItemCompany } from '../types/ItemProperty';
import { IFilter, IcurrentLanguage, IRootState } from '../types/IRootState';

const itemsGetters = {
  getItems(state: any): IItemProperty[] {
    return state.items;
  },
  hasItems(state: IRootState): boolean {
    return state.items.length > 0;
  },
  getAttributeFilteredItems(state: IRootState, getters: any): IItemProperty[] {
    const filteredItems: IItemProperty[] = [];
    const allFilters = {
      values: getters.getCheckedFilters.map((filtered: IFilter) => filtered.value),
      names: getters.getCheckedFilters.map((filtered: IFilter) => filtered.name),
    };
    // -------------------------------------------
    // In this section, filters are grouped in a single object.
    // 'allFilters.names' and 'allFilters.values' are joined to become an object
    // with filters names as unique keys/properties
    // -------------------------------------------
    interface IFiltersObj {
      [key: string]: { values: [any]};
    }
    const groupedFilters: IFiltersObj = {};
    for (const i in allFilters.names) {
      if (!groupedFilters[allFilters.names[i]]) {
        groupedFilters[allFilters.names[i]] = {values: [allFilters.values[i]]};
      } else {
        groupedFilters[allFilters.names[i]].values.push(allFilters.values[i]);
      }
    }
    // --------------------------------------------

    if (allFilters.values.length > 0) {
      state.items.map((item: any) => {
        const attributesArray: any = []; // created array to push every existing attribute per item
        // para cada subfiltro...
        const itemDoesNOTFitFilters = item.productInformation
          .find((information: IInformation) => information.language === 'pt').attributes
          .map((attribute: ItemAttribute) => { // map each item attribute
            attributesArray.push(attribute.name); // populate the attributesArray
            if (groupedFilters[attribute.name]) { // check if the user is filtering by this attribute
              return groupedFilters[attribute.name].values
                .some(value => value === attribute.value); // return true if the attribute value exist in the values array of the specific attribute
            } else {
              return true;
            }
          })
          .includes(false); // verifica se existe algum valor 'false' no array mapeado
        const itemDoesNotHaveSomeFilteredAttribute = Object.keys(groupedFilters).some(filterName => attributesArray.indexOf(filterName) === -1);
        if (!itemDoesNOTFitFilters && !itemDoesNotHaveSomeFilteredAttribute) {
          filteredItems.push(item);
        } else { // caso nao encontre nenhum filtro de atributo, verifica filtros de fabricante e empresas
            const hasManufacturerFilter = item.itemManufacturers
              .map((currentItemManufacturer: IItemManufacturer) => {
                return allFilters.names.includes(currentItemManufacturer.name);
              })
              .includes(true);
            if (hasManufacturerFilter) {
                filteredItems.push(item);
              }
            const hasCompanyFilter = item.itemCompanies
            .map((currentItemCompany: IItemCompany) => {
              return allFilters.names.includes(currentItemCompany.name);
            })
            .includes(true);
            if (hasCompanyFilter) {
              filteredItems.push(item);
            }
            // add new filters
        }
      });
      return filteredItems;
    } else {
      return state.items;
    }
  },
  applyFilters(state: IRootState, getters: any): IItemProperty[] {
    const filteredItems: IItemProperty[] = state.items;
    const customFilters = getters.getCustomAttributeFilters;

    // aplica custom attribute filters
    if (customFilters.length > 0) {

      const filteredByCustomFilters = filteredItems.map((currentItem: any) => {// para cada produto
        const a = customFilters.map((filtroAtual: any) => {

          // get information
          const itemAttributes = currentItem.productInformation
            .find((information: IInformation) => information.language === 'pt').attributes;

          // check if custom attribute matches any attribute
          const validIndex = itemAttributes.findIndex((currentAttribute: any) => filtroAtual.name === currentAttribute.name);
          if (validIndex >= 0) {
            return (itemAttributes[validIndex].value.indexOf(filtroAtual.value) >= 0);
          }
          return false;
        }).every((hasCustomFilter: boolean) => hasCustomFilter === true);
        if (a) { return currentItem; }
        return false;
      }).filter(produtos => produtos !== false);
      return filteredByCustomFilters;
    }
    const filtered = state.onlyClientItems ? filteredItems.filter(item => item.statusERP >= 0) : filteredItems;

    return filtered.slice(0, state.currentMaxItems);
  },
  getItemDescriptionByLanguage: (state: IRootState, getters: any) => (currentItem: any): any => {
    const language: any = getters.getActiveLanguages[0];
    const description: ItemAttribute[] = currentItem.productInformation
      .find((currentInformation: IInformation) => currentInformation.language === language.name).attributes
      .filter((info: ItemAttribute) => info.value !== 'N/A');
    description.shift();
    return {language: language.name, description};
  },
  getItemNameByLanguage: (state: IRootState, getters: any) => (currentItem: any): any => {
    const language: any = getters.getActiveLanguages[0];
    const name: ItemAttribute = currentItem.productInformation
        .find((currentInformation: IInformation) => currentInformation.language.toLowerCase() === language.name.toLowerCase()).attributes[0];
    return {language: language.name, name};
  },
};

export default itemsGetters;
